module.exports = {
    scssVariables: './src/styles/synfun2023',
    defaultLanguage: 'es',
    profileColor: {saturation: 70, brighness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}